import { render, staticRenderFns } from "./scenario-sidebar-icons.vue?vue&type=template&id=4a675120&scoped=true"
import script from "./scenario-sidebar-icons.vue?vue&type=script&lang=js"
export * from "./scenario-sidebar-icons.vue?vue&type=script&lang=js"
import style0 from "./scenario-sidebar-icons.vue?vue&type=style&index=0&id=4a675120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a675120",
  null
  
)

export default component.exports